function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import uniq from "lodash/uniq";
export var defaultLocaleResolver = function defaultLocaleResolver(i18n, locale) {
  var locales = [];
  var list = [];
  locales.push(locale);
  if (!locale) {
    locales.push(i18n.locale);
  }
  if (i18n.enableFallback) {
    locales.push(i18n.defaultLocale);
  }
  locales.filter(Boolean).map(function (entry) {
    return entry.toString();
  }).forEach(function (currentLocale) {
    if (!list.includes(currentLocale)) {
      list.push(currentLocale);
    }
    if (!i18n.enableFallback) {
      return;
    }
    var codes = currentLocale.split("-");
    if (codes.length === 3) {
      list.push("".concat(codes[0], "-").concat(codes[1]));
    }
    list.push(codes[0]);
  });
  return uniq(list);
};
export var Locales = /*#__PURE__*/function () {
  function Locales(i18n) {
    _classCallCheck(this, Locales);
    this.i18n = i18n;
    this.registry = {};
    this.register("default", defaultLocaleResolver);
  }
  _createClass(Locales, [{
    key: "register",
    value: function register(locale, localeResolver) {
      if (typeof localeResolver !== "function") {
        var result = localeResolver;
        localeResolver = function localeResolver() {
          return result;
        };
      }
      this.registry[locale] = localeResolver;
    }
  }, {
    key: "get",
    value: function get(locale) {
      var locales = this.registry[locale] || this.registry[this.i18n.locale] || this.registry.default;
      if (typeof locales === "function") {
        locales = locales(this.i18n, locale);
      }
      if (!(locales instanceof Array)) {
        locales = [locales];
      }
      return locales;
    }
  }]);
  return Locales;
}();